import React, { useState } from 'react'
import Router from 'next/router'
import Modal from 'react-modal'
import { VideoItem } from 'components/lecturePage/VideoItem'
import Layout from 'components/common/Layout'
import * as SC from 'styles/lectureStyles'
import useGetCourse from 'hooks/useGetCourse'
import { CourseByIdItem } from 'models/lectures/EntityModels/lectures'

import { BreadcrumbJsonLd, NextSeo } from 'next-seo'

Modal.setAppElement('#__next')

const CourseDetailPage = ({ currentCourse }) => {
  const [modalVideoUrl, setModalVideoUrl] = useState(null)
  const onVideoClick = url => setModalVideoUrl(url)

  const course = useGetCourse(currentCourse.id)

  return (
    <Layout
      menuButtonColor="black"
    >
      <>
        <NextSeo
          title={currentCourse.items[0]?.course.name}
          description={currentCourse.items[0]?.description}
          canonical={`https://newopen.su/lectures/${currentCourse.id}/${currentCourse.slug}`}
          openGraph={{
            url: `https://newopen.su/lectures/${currentCourse.id}/${currentCourse.slug}`,
            title: `${currentCourse.items[0]?.course.name} | NEW / OPEN`,
            description: `${currentCourse.items[0]?.description}`,
            images: [
              {
                url: '/images/lecturesPage/cover1.png',
                width: 800,
                height: 600,
                alt: 'Course page'
              }
            ]
          }}
        />
        <BreadcrumbJsonLd
          itemListElements={[
            {
              position: 1,
              name: 'Главная',
              item: 'https://newopen.su/'
            },
            {
              position: 2,
              name: 'Лекторий',
              item: 'https://newopen.su/lectures'
            },
            {
              position: 3,
              name: `${currentCourse.items[0]?.course.name}`,
              item: `https://newopen.su/lectures/${currentCourse.id}/${currentCourse.slug}`
            }
          ]}
        />
        <Modal
          isOpen={modalVideoUrl !== null}
          onRequestClose={() => setModalVideoUrl(null)}
          overlayClassName="lectureModal_Overlay"
          className="lectureModal_Content"
          shouldFocusAfterRender={false}
        >
          <SC.CloseModalButton onClick={() => setModalVideoUrl(null)} src="/svgs/circleClose.svg" />
          <iframe src={modalVideoUrl} frameBorder="0" width="100%" height="100%" allowFullScreen />
        </Modal>
        <SC.CourseContainer>
          <SC.Header>
            <SC.BackButtonContainer onClick={() => Router.back()}>
              <SC.BackImg src="/svgs/arrowLeft.svg" />
              <SC.ButtonText className="button-text">Назад</SC.ButtonText>
            </SC.BackButtonContainer>
            <SC.CourseTitle>
              {currentCourse.items[0]?.course.name} <SC.NameSlash>/</SC.NameSlash> {currentCourse.items[0]?.course.year}
            </SC.CourseTitle>
          </SC.Header>
          {course.data?.items?.map((video: CourseByIdItem) => (
            <VideoItem {...video} key={video.id} onVideoClick={onVideoClick} />
          ))}
        </SC.CourseContainer>
      </>
    </Layout>
  )
}

export default CourseDetailPage
